import { styled } from '@linaria/react';
import chroma from 'chroma-js';

function ColorBox({ red, green, blue }) {
  return (
    <BoxWrapper>
      <Channels>
        <Row>
          <Key>R:</Key> {red}
        </Row>
        <Row>
          <Key>G:</Key> {green}
        </Row>
        <Row>
          <Key>B:</Key> {blue}
        </Row>
      </Channels>
      <Box
        style={{ backgroundColor: `rgb(${red}, ${green}, ${blue})` }}
      />
    </BoxWrapper>
  );
}

function RGBColors() {
  return (
    <Wrapper>
      <ColorBox red={0} green={0} blue={0} />
      <ColorBox red={50} green={50} blue={50} />
      <ColorBox red={128} green={128} blue={128} />
      <ColorBox red={220} green={220} blue={220} />
    </Wrapper>
  );
}

const BREAKPOINT = 500;

const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  padding: 0 32px;
  width: 100%;

  @media (max-width: ${BREAKPOINT}px) {
    flex-direction: column;
    padding: 0;
  }
`;

const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${BREAKPOINT}px) {
    flex-direction: row-reverse;
    justify-content: center;
  }
`;

const Box = styled.div`
  width: 100%;
  min-height: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;

  @media (max-width: ${BREAKPOINT}px) {
    width: 50%;
  }
`;

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-family: var(--font-family-mono);
  padding: 0px 8px;

  @media (max-width: ${BREAKPOINT}px) {
    width: 20%;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const Key = styled.div`
  font-weight: var(--font-weight-medium);
`;

export default RGBColors;
